// Centralne kontrakty zdarzeń (runtime-friendly)
// Używane przez normalizację RPC/online i jako źródło prawdy dla pól payloadu.

export type EventPayloadSchema = {
  required: readonly string[];
  numeric?: readonly string[];
  optional?: readonly string[];
  arrayOfObjects?: Record<string, readonly string[]>;
};

export const eventPayloadSchemas: Record<string, EventPayloadSchema> = {
  TURN_END: {
    required: ['playerId', 'finalDice', 'basePoints', 'eventId'],
    numeric: ['basePoints'],
    optional: ['overshotWinScore'],
  },
  SCORE: {
    required: ['playerId', 'delta', 'eventId'],
    numeric: ['delta', 'resultingScore'],
    optional: ['basePoints', 'resultingScore'],
  },
  PENALTY: {
    required: ['playerId', 'delta', 'reason', 'eventId'],
    numeric: ['delta', 'resultingScore'],
    optional: ['resultingScore'],
  },
  OVERTAKE: {
    required: ['overtakerId', 'bonus', 'penalties', 'eventId'],
    numeric: ['bonus'],
    arrayOfObjects: { penalties: ['playerId', 'delta'] },
  },
  DICE_ROLL: {
    required: ['playerId', 'rollIndex', 'dice', 'keptMask', 'eventId'],
    numeric: ['rollIndex'],
  },
  DICE_KEEP: {
    required: ['playerId', 'rollIndex', 'keptMask', 'eventId'],
    numeric: ['rollIndex'],
  },
  PLAYER_READY: {
    required: ['playerId', 'ready', 'eventId'],
  },
  NEXT_GAME_PARTICIPATION: {
    required: ['playerId', 'participating', 'eventId'],
  },
  ORDER_FINALIZED: {
    required: ['order', 'eventId'],
  },
  GAME_CREATED: {
    required: ['eventId'],
  },
  ADD_PLAYER: {
    required: ['playerId', 'name', 'eventId'],
    optional: ['color', 'role', 'mode', 'ready', 'isHost', 'isBot', 'botProfile'],
  },
  VIEWER_JOINED: {
    required: ['viewerId', 'name', 'eventId'],
  },
  PLAYER_LEFT: {
    required: ['playerId', 'eventId'],
    optional: ['reason'],
  },
  ZONE_TRIGGERED: {
    required: ['playerId', 'zoneId', 'kind', 'start', 'end', 'zoneDelta', 'resultingScore', 'eventId'],
    numeric: ['start', 'end', 'zoneDelta', 'overtakeBonus', 'triggerScore', 'resultingScore', 'tier', 'settledIndex'],
    // `links` celowo NIE trafia do arrayOfObjects: walidator wymagałby wtedy tablicy
    // w każdym zdarzeniu, a te sprzed łańcuchów jej nie mają.
    optional: ['tier', 'overtakeBonus', 'penalties', 'triggerScore', 'links', 'settledIndex', 'loop'],
    arrayOfObjects: { penalties: ['playerId', 'delta'] },
  },
  GAME_RESTARTED: {
    required: ['newGameId', 'eventId'],
    // currentRoundId marks the supported same-room reset shape; older events may omit it.
    optional: ['currentRoundId'],
  },
};

